// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.VectorVisualizer {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  font-size: 0.9rem;
  position: relative;
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/VectorVisualizer.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["\n.VectorVisualizer {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  font-size: 0.9rem;\n  position: relative;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
